import { useState } from "react";
import { FormItem, FormLabel, FormControl } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { ImageCropper } from "../shared/ImageCropper";
import { UseFormReturn } from "react-hook-form";

interface ProfilePictureFieldProps {
  form: UseFormReturn<any>;
  initialPreview?: string;
  onImageChange: (file: File) => void;
}

export const ProfilePictureField = ({
  form,
  initialPreview = '',
  onImageChange,
}: ProfilePictureFieldProps) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string>(initialPreview);
  const [showCropper, setShowCropper] = useState(false);

  const handleCroppedImage = (croppedFile: File) => {
    const previewUrl = URL.createObjectURL(croppedFile);
    setPreviewUrl(previewUrl);
    setSelectedFile(croppedFile);
    setShowCropper(false);
    onImageChange(croppedFile);
  };

  return (
    <>
      <FormItem>
        <FormLabel>Profile Picture</FormLabel>
        <FormControl>
          <Input
            type="file"
            accept="image/*"
            className="cursor-pointer"
            onFocus={(e) => e.target.blur()}
            onClick={(e) => {
              // Only allow click if user explicitly clicked
              if (e.isTrusted) {
                (e.target as HTMLInputElement).focus();
              }
            }}
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) {
                setShowCropper(true);
                setSelectedFile(file);
              }
            }}
          />
        </FormControl>
        {previewUrl && (
          <div className="mt-2">
            <Avatar className="w-20 h-20">
              <AvatarImage src={previewUrl} />
              <AvatarFallback>{form.getValues("name")?.[0]}</AvatarFallback>
            </Avatar>
          </div>
        )}
      </FormItem>

      {selectedFile && showCropper && (
        <ImageCropper
          imageFile={selectedFile}
          onCropComplete={handleCroppedImage}
          onCancel={() => {
            setShowCropper(false);
            setSelectedFile(null);
          }}
          aspectRatio={1}
        />
      )}
    </>
  );
};